import { render } from "./DoughnutChart.vue?vue&type=template&id=6c43d71d"
import script from "./DoughnutChart.vue?vue&type=script&lang=js"
export * from "./DoughnutChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__